import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function Contato() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    empresa: '',
    assunto: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    
    try {
      const submitFormData = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        submitFormData.append(key, value);
      });
      
      const response = await fetch('https://readdy.ai/api/form/d3m09ni96ie05rb9mf0g', {
        method: 'POST',
        body: submitFormData
      });
      
      if (response.ok) {
        setSubmitMessage('Mensagem enviada com sucesso! Entraremos em contato em breve.');
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          empresa: '',
          assunto: '',
          mensagem: ''
        });
        setTimeout(() => setSubmitMessage(''), 5000);
      } else {
        setSubmitMessage('Erro ao enviar mensagem. Tente novamente.');
        setTimeout(() => setSubmitMessage(''), 5000);
      }
    } catch (error) {
      setSubmitMessage('Erro ao enviar mensagem. Tente novamente.');
      setTimeout(() => setSubmitMessage(''), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDepartmentContact = (whatsappLink: string) => {
    window.open(whatsappLink, '_blank');
  };

  const handleSocialClick = (platform: string) => {
    const urls: Record<string, string> = {
      facebook: 'https://www.facebook.com/?locale=pt_BR',
      instagram: 'https://www.instagram.com/tecnutrifoodservice/',
      linkedin: 'https://linkedin.com/company/sustentare',
      whatsapp: 'https://wa.me/551938528200'
    };
    
    window.open(urls[platform], '_blank');
  };

  const contactInfo = [
    {
      icon: 'ri-phone-line',
      title: 'Telefone',
      info: '(19) 3852-8200',
      description: 'Segunda a sexta, 8h às 18h',
      action: () => window.location.href = 'tel:+551938528200'
    },
    {
      icon: 'ri-mail-line',
      title: 'E-mail',
      info: 'contato@sustentare.com.br',
      description: 'Responde rapidamente',
      action: () => window.location.href = 'mailto:contato@sustentare.com.br'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Endereço',
      info: 'Estr. Mun. Fioravante Carlotti, 1901',
      description: 'Pedreira - SP, 13920-000',
      action: () => window.open('https://maps.google.com/?q=Estr.+Mun.+Fioravante+Carlotti+1901+Pedreira+SP', '_blank')
    },
    {
      icon: 'ri-time-line',
      title: 'Horário de Funcionamento',
      info: 'Segunda a Sexta: 7h às 17h',
      description: 'Sábado e Domingo: fechado',
      action: () => {
        const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
        if (widget) {
          widget.click();
        }
      }
    }
  ];

  const departments = [
    {
      name: 'Representante São Paulo Capital',
      email: 'regsp@sustentare.com.br',
      phone: '+55 (11) 94013-6064',
      whatsappLink: 'https://wa.me/5511940136064',
      description: 'Orçamentos e pedidos'
    },
    {
      name: 'Representante São Paulo Interior',
      email: 'regintsp@sustentare.com.br',
      phone: '+55 (19) 99763-7070',
      whatsappLink: 'https://wa.me/19997637070',
      description: 'Orçamentos e pedidos'
    },
    {
      name: 'Representante Sul',
      email: 'regsul@sustentare.com.br',
      phone: '+55 (47) 99921-8772',
      whatsappLink: 'https://wa.me/47999218772',
      description: 'Orçamentos e pedidos'
    },
    {
      name: 'Representante Sudeste / Centro Oeste',
      email: 'regsudeste@sustentare.com.br',
      phone: '+55 (21) 98393-7046',
      whatsappLink: 'https://wa.me/21983937046',
      description: 'Orçamentos e pedidos'
    },
    {
      name: 'Representante Norte / Nordeste',
      email: 'regnordeste@sustentare.com.br',
      phone: '+55 (81) 98896-8132',
      whatsappLink: 'https://wa.me/81988968132',
      description: 'Orçamentos e pedidos'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(220, 38, 38, 0.8), rgba(185, 28, 28, 0.8)), url('https://readdy.ai/api/search-image?query=modern%20office%20reception%20area%20with%20professional%20customer%20service%2C%20business%20communication%2C%20contact%20center%2C%20professional%20meeting%20space%2C%20corporate%20environment&width=1920&height=600&seq=contactHero&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-red-600/90 to-red-700/90"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Entre em Contato
          </h1>
          <p className="text-xl md:text-2xl text-red-100 max-w-3xl mx-auto">
            Estamos aqui para ajudar você a encontrar as melhores soluções para seu negócio
          </p>
        </div>
      </section>

      <main className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Contact Info Cards */}
          <section className="mb-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {contactInfo.map((item, index) => (
                <Card key={index} className="text-center cursor-pointer hover:shadow-lg transition-all hover:scale-105" onClick={item.action}>
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${item.icon} text-2xl text-red-600`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-red-600 font-medium mb-1">{item.info}</p>
                  <p className="text-gray-600 text-sm">{item.description}</p>
                </Card>
              ))}
            </div>
          </section>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            
            {/* Contact Form */}
            <section>
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Envie sua Mensagem
                </h2>
                <p className="text-xl text-gray-600">
                  Preencha o formulário abaixo e nossa equipe entrará em contato em breve
                </p>
              </div>

              <Card>
                <form onSubmit={handleSubmit} data-readdy-form id="contact-form" className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">
                        Nome Completo *
                      </label>
                      <input
                        type="text"
                        id="nome"
                        name="nome"
                        required
                        value={formData.nome}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500 transition-all"
                        placeholder="Seu nome completo"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                        E-mail *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500 transition-all"
                        placeholder="seu@email.com"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="telefone" className="block text-sm font-medium text-gray-700 mb-2">
                        Telefone
                      </label>
                      <input
                        type="tel"
                        id="telefone"
                        name="telefone"
                        value={formData.telefone}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500 transition-all"
                        placeholder="(11) 99999-9999"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="empresa" className="block text-sm font-medium text-gray-700 mb-2">
                        Empresa
                      </label>
                      <input
                        type="text"
                        id="empresa"
                        name="empresa"
                        value={formData.empresa}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500 transition-all"
                        placeholder="Nome da sua empresa"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="assunto" className="block text-sm font-medium text-gray-700 mb-2">
                      Assunto *
                    </label>
                    <select
                      id="assunto"
                      name="assunto"
                      required
                      value={formData.assunto}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500 pr-8 cursor-pointer transition-all"
                    >
                      <option value="">Selecione um assunto</option>
                      <option value="orcamento">Solicitar Orçamento</option>
                      <option value="produtos">Dúvidas sobre Produtos</option>
                      <option value="suporte">Suporte Técnico</option>
                      <option value="parceria">Parceria Comercial</option>
                      <option value="outros">Outros</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="mensagem" className="block text-sm font-medium text-gray-700 mb-2">
                      Mensagem *
                    </label>
                    <textarea
                      id="mensagem"
                      name="mensagem"
                      required
                      rows={6}
                      maxLength={500}
                      value={formData.mensagem}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 focus:border-red-500 resize-none transition-all"
                      placeholder="Descreva sua necessidade ou dúvida..."
                    />
                    <p className="text-sm text-gray-500 mt-1">
                      {formData.mensagem.length}/500 caracteres
                    </p>
                  </div>

                  {submitMessage && (
                    <div className={`p-4 rounded-lg animate-fade-in ${
                      submitMessage.includes('sucesso') 
                        ? 'bg-green-100 text-green-800 border border-green-200' 
                        : 'bg-red-100 text-red-800 border border-red-200'
                    }`}>
                      <div className="flex items-center gap-2">
                        <i className={`${submitMessage.includes('sucesso') ? 'ri-checkbox-circle-line' : 'ri-error-warning-line'} text-xl`}></i>
                        <span>{submitMessage}</span>
                      </div>
                    </div>
                  )}

                  <Button type="submit" size="lg" className="w-full whitespace-nowrap" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <i className="ri-loader-4-line mr-2 animate-spin"></i>
                        Enviando...
                      </>
                    ) : (
                      <>
                        <i className="ri-send-plane-line mr-2"></i>
                        Enviar Mensagem
                      </>
                    )}
                  </Button>
                </form>
              </Card>
            </section>

            {/* Additional Info */}
            <section className="space-y-8">
              
              {/* Departments */}
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  Departamentos Especializados
                </h3>
                <div className="space-y-4">
                  {departments.map((dept, index) => (
                    <Card 
                      key={index} 
                      className="hover:shadow-lg transition-all hover:scale-105 cursor-pointer"
                      onClick={() => handleDepartmentContact(dept.whatsappLink)}
                    >
                      <div className="flex items-start gap-4">
                        <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                          <i className="ri-team-line text-xl text-red-600"></i>
                        </div>
                        <div className="flex-1">
                          <h4 className="font-semibold text-lg text-gray-900 mb-1">{dept.name}</h4>
                          <p className="text-gray-600 text-sm mb-2">{dept.description}</p>
                          <div className="space-y-1">
                            <p className="text-sm flex items-center">
                              <i className="ri-mail-line mr-2 text-red-600"></i>
                              <a 
                                href={`mailto:${dept.email}`}
                                className="text-red-600 hover:underline"
                                onClick={(e) => e.stopPropagation()}
                              >
                                {dept.email}
                              </a>
                            </p>
                            <p className="text-sm flex items-center">
                              <i className="ri-whatsapp-line mr-2 text-red-600"></i>
                              <a 
                                href={dept.whatsappLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-red-600 hover:underline"
                                onClick={(e) => e.stopPropagation()}
                              >
                                {dept.phone}
                              </a>
                            </p>
                          </div>
                        </div>
                        <div className="flex-shrink-0">
                          <i className="ri-arrow-right-line text-gray-400 text-xl"></i>
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              </div>

              {/* Map */}
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  Nossa Localização
                </h3>
                <Card padding="sm">
                  <div className="aspect-video rounded-lg overflow-hidden">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3677.8!2d-46.9!3d-22.74!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDQ0JzI0LjAiUyA0NsKwNTQnMDAuMCJX!5e0!3m2!1spt-BR!2sbr!4v1635959999999!5m2!1spt-BR!2sbr&q=Estr.+Mun.+Fioravante+Carlotti,+1901,+Pedreira+-+SP,+13920-000"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Localização Sustentare"
                    />
                  </div>
                </Card>
              </div>

              {/* Social Media */}
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  Siga-nos nas Redes Sociais
                </h3>
                <div className="flex gap-4">
                  <button
                    onClick={() => handleSocialClick('facebook')}
                    className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center text-white hover:bg-blue-700 transition-all hover:scale-110 cursor-pointer"
                    aria-label="Facebook"
                  >
                    <i className="ri-facebook-fill text-xl"></i>
                  </button>
                  <button
                    onClick={() => handleSocialClick('instagram')}
                    className="w-12 h-12 bg-pink-600 rounded-lg flex items-center justify-center text-white hover:bg-pink-700 transition-all hover:scale-110 cursor-pointer"
                    aria-label="Instagram"
                  >
                    <i className="ri-instagram-line text-xl"></i>
                  </button>
                  <button
                    onClick={() => handleSocialClick('linkedin')}
                    className="w-12 h-12 bg-blue-400 rounded-lg flex items-center justify-center text-white hover:bg-blue-500 transition-all hover:scale-110 cursor-pointer"
                    aria-label="LinkedIn"
                  >
                    <i className="ri-linkedin-fill text-xl"></i>
                  </button>
                  <button
                    onClick={() => handleSocialClick('whatsapp')}
                    className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center text-white hover:bg-green-700 transition-all hover:scale-110 cursor-pointer"
                    aria-label="WhatsApp"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}